// 通用文本翻譯

export const common = {
    loading: '載入中...',
    back: '返回',
    download: '下載',
    loadMore: '載入更多',
    save: '儲存',
    cancel: '取消',
    confirm: '確認',
    delete: '刪除',
    edit: '編輯',
    submit: '提交',
    close: '關閉',
    yes: '是',
    no: '否',
    ok: '確定',
    error: '錯誤',
    success: '成功',
    warning: '警告',
    info: '資訊',
    retry: '重試',
    reset: '重置'
  };
